import {
    ADDEDITUSER_SUCCESS,
    ADDEDITUSER_FAILED,
    RESET_ADDEDITUSER,
    LOADING_ADDEDITUSER,
    NETWORK_ERROR_ADDEDITUSER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDEDITUSER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case ADDEDITUSER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case ADDEDITUSER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_ADDEDITUSER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_ADDEDITUSER:
            return (state = initialState);
        default:
            return state;
    }
};
